// extracted by mini-css-extract-plugin
export var resizer = "_gh-0";